import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import * as deepmerge from 'deepmerge';
import { environment } from '../../environments/environment';
import { UserInfo } from './user-info.service';

export class PruningTranslationLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string,
    private suffix: string,
    private userInfo?: UserInfo
  ) {}

  public getTranslation(lang: string): any {
    const resources = [`${this.prefix}${lang}${this.suffix}`];
    if (this.userInfo)
      resources.push(
        `${this.prefix}${lang}-${this.userInfo?.company.id}${this.suffix}`
      );

    const params = new HttpParams().set('v', environment.appVersion);

    return combineLatest(
      resources.map(path =>
        this.http.get(path, { params: params }).pipe(
          map((res: object) => this.process(res)),
          catchError(res => {
            console.error(
              'Something went wrong for the following translation file:',
              path
            );
            console.error(res.message);
            return of({});
          })
        )
      )
    ).pipe(
      map(response => {
        return deepmerge.all(response);
      })
    );
  }

  private process(object: any): object {
    const newObject: any = {};

    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (typeof object[key] === 'object') {
          newObject[key] = this.process(object[key]);
        } else if (typeof object[key] === 'string' && object[key] === '') {
          // do not copy empty strings
        } else {
          newObject[key] = object[key];
        }
      }
    }

    return newObject;
  }
}
